import {
  COMPANY_FILTER_APPLY,
  COMPANY_FILTER_CHANGE,
  FETCH_SELECTED_COMPANY_DATA_ASYNC,
} from './constants'

export const applyCompanyFilter = (selectedCompany) => ({
  type: COMPANY_FILTER_APPLY,
  payload: { selectedCompany },
})
export const companyFilterChange = (selectedCompany) => ({
  type: COMPANY_FILTER_CHANGE,
  payload: { selectedCompany },
})

export const fetchSelectedCompanyDataSuccess = (data) => ({
  type: FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchSelectedCompanyDataError = (error) => ({
  type: FETCH_SELECTED_COMPANY_DATA_ASYNC.ERROR,
  error,
})
